import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared.module';
import { LockerLocationPage } from './locker-location.page';


@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [LockerLocationPage]
})
export class LockerTypePageModule {}
